// Any config specific to OMAN?

export default {
  code: 'OMN',
  countryName: 'Oman',
  googleSiteVerificationCode: ['kanihyduaeRWrotFKPjt5utDrUw4Up9I7-i7T5FHNIo'],
  countryDomain: 'https://www.carrefourbahrain.com',
  helplineNumber: '800 73232',
  latitude: 23.607566533780076,
  longitude: 58.48993923890195,
  defaultAreaCode: 'Qurm - Muscat',
  features: {
    languageChange: true,
    now: false,
    share: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: 'd8679b1a-f1b4-4150-b168-913ce32399c7'
  }
}
